import { render, staticRenderFns } from "./show.events.page.vue?vue&type=template&id=b13f136e&scoped=true&"
import script from "./show.events.page.vue?vue&type=script&lang=js&"
export * from "./show.events.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13f136e",
  null
  
)

export default component.exports